'use strict';

function FlightManagementModePanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'FlightManagementModePanelController',
    template: require('../templates/flight-management-mode-panel.html'),
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', scope.onFlightSummaryRowSelectionChanged);
      scope.$on('overrides:saved', scope.populateOverridesToScreenState);
      scope.$watch('screenState.flightManagementMode.visible', scope.clearUserOverridesFromScreenState);
    }
  };
}
FlightManagementModePanelDirective.$inject = [];
module.exports = FlightManagementModePanelDirective;